/* eslint-disable @typescript-eslint/no-unused-vars */
import { RdmInterface } from 'src/app/shared-resources/interfaces/rdm-client.interface';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Body, POST, RebirthHttp, GET, Query } from 'rebirth-http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Signup } from '../interfaces/signup.interface';

@Injectable()
export class SignupService extends RebirthHttp {
  constructor(http: HttpClient) {
    super(http);
  }

  @POST(
    environment.wso2amEndPoint +
      environment.identityServerName +
      environment.wso2amApiVersion +
      '/public/v1/auth'
  )
  signup(@Body reg: Signup): Observable<any> | null {
    return null; // leave `return null` due to TypeScript Interface isn't visable in runtime
  }

  @GET(
    environment.wso2amEndPoint +
      '/rdm' +
      environment.wso2amApiVersion +
      '/public/v1/types'
  )
  getPublicLOVs(@Query('label') label: any): Observable<RdmInterface> | null {
    return null;
  }
  manipulateData(val: any) {
    const temp = [];
    if (val['content'] === undefined) {
      const rdmData = { content: [val] };
      val = rdmData;
    }
    for (let i = 0; i < val.content.length; i++) {
      for (let j = 0; j < val.content[i].refValue.length; j++) {
        if (!val.content[i].refValue[j].label) {
          val.content[i].refValue[j]['label'] = val.content[i].refValue[j].code;
        }
        if (!val.content[i].refValue[j].value) {
          val.content[i].refValue[j]['value'] = val.content[i].refValue[j].code;
        }
        temp.push(val.content[i].refValue[j]);
      }
    }
    return temp;
  }
}
